import { TRPCClientErrorLike } from "@trpc/client";

export function getMessageFromNetworkError(error: TRPCClientErrorLike<any>) {
  const message = error.data?.message || error.message;
  const status = error.data?.httpStatus;
  const name = error.data?.name || (error as any).name;

  // TRPCClientError 403: Forbidden
  if (name && status && message) {
    console.error(`${name} ${status}: ${message}`);
  }
  // TRPCClientError: Forbidden
  else if (name && message) {
    console.error(`${name}: ${message}`);
  }
  // 403: Forbidden
  else if (status && message) {
    console.error(`${status}: ${message}`);
  } else {
    console.error(message);
  }

  // Forbidden
  return message;
}
